import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
const deleteCollection = async ({ id }) => Collections.remove(id);
const bulkDeleteCollections = async ({ entityIds }) => Collections.bulkDelete({ entity_ids: entityIds });
const createCollection = async (collectionRequest) => {
  var _a;
  const { share_request, ...rest } = collectionRequest;
  return Collections.create({
    entity: {
      title: rest == null ? void 0 : rest.title,
      description: rest == null ? void 0 : rest.description,
      id: rest == null ? void 0 : rest.id,
      entities: rest == null ? void 0 : rest.entities
    },
    share_request: {
      selected_grantee_capabilities: (_a = share_request == null ? void 0 : share_request.selected_grantee_capabilities) == null ? void 0 : _a.toJS(),
      selected_collections: share_request == null ? void 0 : share_request.selected_collections
    }
  });
};
const updateCollection = async (newCollection) => Collections.update(newCollection.id, {
  title: newCollection == null ? void 0 : newCollection.title,
  description: newCollection == null ? void 0 : newCollection.description
});
const updateCollectionsForEntity = async ({
  entityId,
  payload
}) => Collections.updateCollections(entityId, { add_to: payload.addTo, remove_from: payload.removeFrom });
const useCollectionMutation = () => {
  const queryClient = useQueryClient();
  const remove = useMutation({
    mutationFn: deleteCollection,
    onError: (errorThrown) => {
      UserNotification.error(`Deleting Collection failed with status: ${errorThrown}`, "Could not delete Collection");
    },
    onSuccess: () => {
      UserNotification.success("Collection has been successfully deleted.", "Success!");
      queryClient.invalidateQueries({ queryKey: [COLLECTIONS_QUERY_KEY], type: "active" });
    }
  });
  const bulkRemove = useMutation({
    mutationFn: bulkDeleteCollections
  });
  const updateEntityCollectionsMutation = useMutation({
    mutationFn: updateCollectionsForEntity,
    onError: (errorThrown) => {
      UserNotification.error(
        `Updating entity collection(s) failed with status: ${errorThrown}`,
        "Could not update entity collections"
      );
    },
    onSuccess: () => {
      UserNotification.success("Entity collection(s) has been successfully updated.", "Success!");
      queryClient.refetchQueries({ queryKey: [COLLECTIONS_QUERY_KEY, "entity"], type: "active" });
    }
  });
  const create = useMutation({
    mutationFn: createCollection,
    onError: (errorThrown) => {
      UserNotification.error(`Creating Collection failed with status: ${errorThrown}`, "Could not create Collection");
    },
    onSuccess: () => {
      UserNotification.success("Collection has been successfully created.", "Success!");
      queryClient.refetchQueries({ queryKey: [COLLECTIONS_QUERY_KEY], type: "active" });
    }
  });
  const update = useMutation({
    mutationFn: updateCollection,
    onError: (errorThrown) => {
      UserNotification.error(`Updating Collection failed with status: ${errorThrown}`, "Could not update Collection");
    },
    onSuccess: () => {
      UserNotification.success("Collection has been successfully updated.", "Success!");
      queryClient.refetchQueries({ queryKey: [COLLECTIONS_QUERY_KEY], type: "active" });
    }
  });
  return {
    deleteCollection: remove.mutateAsync,
    bulkDeleteCollectionsMutation: bulkRemove,
    createCollection: create.mutateAsync,
    updateCollection: update.mutateAsync,
    updateEntityCollectionsMutation: updateEntityCollectionsMutation.mutateAsync
  };
};
export default useCollectionMutation;
